import { Badge, BadgeEntryData } from '../pages/leaderboard/model';
import { BADGE_IDS } from './constants';

/**
 * Formats daysActive as "X/7" string for display.
 */
export const formatTriggersMet = (daysActive: number): string => {
  return `${daysActive}/7`;
};

/**
 * Extracts the rank-1 topSites entry from badge data.
 * Returns null if no topSites badge or no entries exist.
 */
export const getBestSite = (badges: Badge[]): BadgeEntryData | null => {
  const topSites = badges.find(b => b.badgeId === BADGE_IDS.TOP_SITES);
  if (!topSites || topSites.entries.length === 0) return null;
  return topSites.entries.find(e => e.rank === 1) || topSites.entries[0];
};
